import {useAlert} from "react-alert";

export const useErrorHandle = () => {
    const alert = useAlert()
    return (error: any) => {
        console.error(error)
        alert.show(
            error?.response?.status === 401 ?
                'Usuário ou senha incorretos' :
                error?.response?.data?.message?.[0] && error?.response?.status !== 500
                    ?
                    error?.response?.data?.message?.[0] :
                    typeof error?.message === "string" ?
                        error?.message :
                        'Houve um erro desconhecido, por favor, tente novamente ou entre em contato com o administrador do sistema',
            {
                timeout: 8000,
                type: 'error'
            }
        )
    }
}